import { Inject, Injectable, Optional } from '@angular/core';
import { IsNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { RESPONSE } from '../../express.tokens';
import { Response } from 'express';

@Injectable({
  providedIn: 'root'
})
export class SsrResponseService {
  private response: Response;

  constructor(@Optional() @Inject(RESPONSE) response: Response) {
    this.response = response;
  }

  SetStatusCode(code: number, message?: string) {
    if (!this.response) {
      return;
    }

    this.response.statusCode = code;

    if (message) {
      this.response.statusMessage = message;
    }
  }


  NotFound(message = 'Not Found') {
    if (!this.response) {
      return;
    }

    this.response.statusCode = 404;
    this.response.statusMessage = message;
  }

  PermanentRedirect(newUrl: string) {
    if (!this.response) {
      return;
    }

    // this.SetHeader("IsPermanentRedirect", "1");
    this.response.redirect(301, newUrl);
    this.response.finished = true;
    this.response.end();
  }

  InternalServerError(message = 'Internal Server Error') {
    if (!this.response) {
      return;
    }

    this.response.statusCode = 500;
    this.response.statusMessage = message;
  }

  SetHeader(key: string, value: string) {
    if (!this.response || IsNullOrEmpty(key) || IsNullOrEmpty(value)) {
      return;
    }

    this.response.set(key, value);
  }
}